module.exports = __webpack_public_path__ + "img/Lobby_Banner4.126c0749.jpg";